import _ from 'lodash';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SharedService } from './shared.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class VirtualEventService {

  constructor(
    private http: HttpClient,
    private sharedService: SharedService,
    private cookieService: CookieService
  ) { }

  createVirtualEvent(data: any) {
    const token = this.cookieService.get('accessToken');
    const transformedData = JSON.stringify(data);
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(transformedData)}`
    ];
    return this.http.post('/api/vevent/create', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getVirtualEvent(id: number) {
    return this.http.post('/api/vevent/get', `id=${id}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updateVirtualEvent(data: any) {
    const token = this.cookieService.get('accessToken');
    const transformedData = JSON.stringify(data);
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(transformedData)}`
    ];
    return this.http.post('/api/vevent/update', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updateVirtualEventStream(data: any) {
    const token = this.cookieService.get('accessToken');
    const transformedData = JSON.stringify(data);
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(transformedData)}`
    ];
    return this.http.post('/api/vevent/stream/update', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getVirtualEventSummary(vEventId: number) {
    return this.http.post('/api/vevent/summary', `vEventId=${vEventId}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updateStatus(id, status) {
    const token = this.cookieService.get('accessToken');
    const p = `{"id":"${id}","runStatus":${status}}`;
    return this.http.post('/api/vevent/setRunStatus', `access_token=${token}&p=${p}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updatePresent(eventId, campaignId, optionId, clear = false) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p={"eventId":"${eventId}","campaignId":"${campaignId}","optionId":"${optionId}"${clear ? `,"clear":true`: ``}}`
    ]
    return this.http.post('/api/vevent/changeCampaign', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getLastHero(vEventId, campaignId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p={"vEventId":"${vEventId}","campaignId":"${campaignId}"}`
    ];
    return this.http.post('/api/vevent/getLastMan', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  declareLastHero(vEventId, campaignId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p={"vEventId":"${vEventId}","campaignId":"${campaignId}"}`
    ];
    return this.http.post('/api/vevent/declareLastMan', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  finalizeAuctionItem(eventId, campaignId, optionId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p={"eventId":"${eventId}","campaignId":"${campaignId}","optionId":"${optionId}"}`
    ];
    return this.http.post('/api/vevent/finalizeAuctionItem', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  closeSilentAuction(vEventId, campaignId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p={"vEventId":"${vEventId}","campaignId":"${campaignId}"}`
    ];
    return this.http.post('/api/vevent/closeSilentAuction', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  finalizeAuction(vEventId, campaignId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p={"vEventId":"${vEventId}","campaignId":"${campaignId}"}`
    ];
    return this.http.post('/api/auction/finalize', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  removeAuctionBid(bidId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `bidId=${bidId}`
    ];
    return this.http.post('/api/auction/item/bid/remove', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  showLiveAuctionMulti(eventId, campaignId, optionId, amount) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p={"eventId":"${eventId}","campaignId":"${campaignId}","optionId":"${optionId}","amount":${amount}}`
    ];
    return this.http.post('/api/vevent/showLiveAuctionMulti', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  setPresentationMode(eventId, presentationMode) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p={"eventId":"${eventId}","presentationMode":${presentationMode}}`
    ];
    return this.http.post('/api/vevent/setPresentationMode', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }
}
